export default __webpack_public_path__ + "images/online-payment/gpwebpay.png?0b9b7889c640be2ef76c21a5e8a6c98d96e723527ff5e4a979aa119ba1b4d2d7";